var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5312 22.4062C57.5625 24.5625 60 28.5938 60 33C60 39.6562 54.5625 45 48 45H13.5C6 45 0 39 0 31.5C0 25.7812 3.65625 20.7188 9 18.8438C9.375 10.0312 16.5938 3 25.5 3C31.0312 3 36 5.8125 39 10.0312C40.4062 9.375 41.9062 9 43.5 9C49.2188 9 54 13.7812 54 19.5C54 20.5312 53.8125 21.4688 53.5312 22.4062ZM48 42C52.9688 42 57 37.9688 57 33C57 28.5938 53.7188 24.8438 49.4062 24.1875C50.3438 22.875 51 21.2812 51 19.5C51 15.375 47.625 12 43.5 12C41.25 12 39.375 12.9375 37.9688 14.4375C35.9062 9.46875 31.125 6 25.5 6C18 6 12 12.0938 12 19.5C12 20.0625 12 20.625 12.0938 21.0938C6.9375 21.8438 3 26.25 3 31.5C3 37.3125 7.6875 42 13.5 42H48Z",
    fill: "#17AEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6a6b9c7c7b24413ab47ab1dd05025370.svg";
export { ForwardRef as ReactComponent };